export enum Routes {
    // Auth
    Auth = "/auth",
    AuthLogin = "/auth/login",
    AuthSignUp = "/auth/signup",

    // App
    IntegrationList = "/list",
    IntegrationCreate = "/integration/create",
    IntegrationEditor = "/integration/editor/:id",
    IntegrationEditorAuth = "/integration/editor/:id/authentication",
    IntegrationEditorAuthEdit = "/integration/editor/:id/authentication/edit/:authId",
    IntegrationEditorAuthFieldsAddEdit = "/integration/editor/:id/authentication/edit/:authId/fields/:fieldId",
    IntegrationEditorAuthFieldsAdd = "/integration/editor/:id/authentication/add/:authId/fields/",
    IntegrationEdit = "/integration/editor/:id/update",
    IntegrationEditorHome = "/integration/editor/:id/home",
    IntegrationEditorTrigger = "/integration/editor/:id/trigger",
    IntegrationEditorTriggerAdd = "/integration/editor/:id/trigger/add",
    IntegrationEditorTriggerEditor = "/integration/editor/:id/trigger/:triggerId",
    IntegrationEditorAction = "/integration/editor/:id/action",
    IntegrationEditorActionsEditor = "/integration/editor/:id/action/:actionId",
    IntegrationEditorActionAdd = "/integration/editor/:id/add/action",
    ConnectionCreate = "/connection/:integrationId"

}
